var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesBubbleSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 1.74999C9.93933 1.74449 6.42568 3.80692 4.5728 7.1368C2.71991 10.4667 2.81953 14.5397 4.833 17.775L1.75 24.25L8.224 21.166C12.0101 23.5209 16.8706 23.2279 20.3464 20.4351C23.8222 17.6424 25.1551 12.959 23.6708 8.75458C22.1865 4.55015 18.2087 1.74163 13.75 1.74999Z",
    stroke: "#758ABD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11.875C9.04289 11.875 8.875 12.0429 8.875 12.25C8.875 12.4571 9.04289 12.625 9.25 12.625C9.45711 12.625 9.625 12.4571 9.625 12.25C9.625 12.0429 9.45711 11.875 9.25 11.875",
    stroke: "#758ABD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.875C13.5429 11.875 13.375 12.0429 13.375 12.25C13.375 12.4571 13.5429 12.625 13.75 12.625C13.9571 12.625 14.125 12.4571 14.125 12.25C14.125 12.0429 13.9571 11.875 13.75 11.875",
    stroke: "#758ABD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 11.875C18.0429 11.875 17.875 12.0429 17.875 12.25C17.875 12.4571 18.0429 12.625 18.25 12.625C18.4571 12.625 18.625 12.4571 18.625 12.25C18.625 12.0429 18.4571 11.875 18.25 11.875",
    stroke: "#758ABD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBubbleSecond);
export default __webpack_public_path__ + "static/media/messages-bubble-second.b3659921.svg";
export { ForwardRef as ReactComponent };